// ClientForm.jsx
import React, { useState, useEffect } from "react";
import axios from "axios";
import "./ClientForm.css"; // Create and import custom CSS for styling

const ClientForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    contactNo: "",
    emailId: "",
    aadharAddress: "",
    workForMaid: "",
    maidWorkingAddress: "",
    registrationFees: "",
    dateOfJoining: "",
    place: "",
    date: new Date().toISOString().split("T")[0], // Current date
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(
        "https://api.dremerz.net/api/Project_17_ManPowerWebsite_Client_Aplication_Form",
        formData
      );
      alert("Form Submitted Successfully");
    } catch (error) {
      alert("Failed to submit form");
      console.error(error);
    }
  };
  useEffect(() => {
    const element = document.getElementById("client");
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  }, []);

  return (
    <div
      id="client"
      className="ClientForm-container d-flex justify-content-center align-items-center"
    >
      <form className="ClientForm-form" onSubmit={handleSubmit}>
        <h2 className="ClientForm-title">Fill Up Submit Here </h2>
        <p style={{ textAlign: "center" }}>
          Our Team Will Get Bact To You Soon
        </p>
        <div className="row mt-5">
          <div className="col-md-6 mb-3">
            <label style={{marginTop: "10px"}} htmlFor="name">Your Name <span style={{color: "red"}}>*</span></label>
            <input
              type="text"
              name="name"
              id="name"
              className="ClientForm-input req-star"
              value={formData.name}
              onChange={handleChange}
              required
            />
          </div>
          <div className="col-md-6 mb-3">
          <label style={{marginTop: "10px"}} htmlFor="number">Mobile Number <span style={{color: "red"}}>*</span></label>
            <input
              type="text"
              id="number"
              maxLength={10}
              name="contactNo"
              className="ClientForm-input req-star"
              value={formData.contactNo}
              onChange={handleChange}
              required
            />
          </div>
          <div className="col-md-6 mb-3">
          <label style={{marginTop: "10px"}} htmlFor="email">Email Address <span style={{color: "red"}}>*</span></label>
            <input
              type="email"
              id="email"
              name="emailId"
              className="ClientForm-input req-star"
              value={formData.emailId}
              onChange={handleChange}
              required
            />
          </div>
          <div className="col-md-6 mb-3">
            <label style={{marginTop: "10px"}} htmlFor="hire">Hiring the maid for what work</label>
            <input
              type="text"
              id="hire"
              name="workForMaid"
              className="ClientForm-input"
              value={formData.workForMaid}
              onChange={handleChange}
            />
          </div>
          <div className="col-md-6 mb-3">
            <label style={{marginTop: "10px"}} htmlFor="date">Date </label>
            <input
              type="date"
              name="dateOfJoining"
              id="date"
              className="ClientForm-input"
              value={formData.dateOfJoining}
              onChange={handleChange}
            />
          </div>
          <div className="col-12 mb-3">
            <label style={{marginTop: "10px"}} htmlFor="place">Place</label>
            <input
              type="text"
              id="place"
              name="place"
              className="ClientForm-input"
              value={formData.place}
              onChange={handleChange}
            />
          </div>
        </div>
        <button type="submit" className="ClientForm-submit">
          SEND MESSAGE <i className="bi bi-arrow-up-right"></i>
        </button>
      </form>
    </div>
  );
};

export default ClientForm;
